import {
  SUBSTITUTION_CHARACTER,
  WatchProjectLanguages,
} from "../../../plugins/watchproject-localized-urls/const"
import urlMap from "../../../plugins/watchproject-localized-urls/url-mappings.json"

// TODO: check type error for language
export const getUrlMappingEntry = (currentUrl: string, language: string) => {
  return urlMap.find(mapEntry =>
    currentUrl.match(mapEntry.matchPaths[language as WatchProjectLanguages])
  )
}

export const getUrlMappingEntryByRouteKey = (routeKey: string) => {
  return urlMap.find(mapEntry => mapEntry.route === routeKey)
}

export const generateNewTranslatedUrl = (
  currentUrl: string,
  oldLanguage: string,
  newLanguage: string
) => {
  const pathMappingObject = getUrlMappingEntry(currentUrl, oldLanguage)

  if (!pathMappingObject) {
    return { url: currentUrl, pathMappingObject }
  }

  if (pathMappingObject.needsSubstitution) {
    // TODO: check if slug routes work correctly
    const preSubstitutionCharacterString =
      pathMappingObject.translations[
        newLanguage as WatchProjectLanguages
      ].split("{*}")[0]
    const postSubstitutionCharacterString =
      pathMappingObject.translations[
        newLanguage as WatchProjectLanguages
      ].split("{*}")[1]

    const slug = currentUrl
      .replace(preSubstitutionCharacterString, "")
      .replace(postSubstitutionCharacterString, "")

    const url = pathMappingObject.translations[
      newLanguage as WatchProjectLanguages
    ]
      .replace(SUBSTITUTION_CHARACTER, slug)
      .replace("//", "/")

    return { url, pathMappingObject }
  }

  return {
    url: pathMappingObject.translations[newLanguage as WatchProjectLanguages],
    pathMappingObject,
  }
}
